/* Fallback de Suspense do code-splitting por rota (ver app/router.tsx):
   cada tela é um chunk próprio e baixa sob demanda. Spinner discreto
   enquanto o chunk carrega — no app o shell permanece (Suspense interno
   do AppLayout/AdminLayout). */
export function RouteFallback() {
  return (
    <div style={{ display: "grid", placeItems: "center", minHeight: "50vh" }}>
      <div className="spinner spinner-dark" aria-label="Carregando" />
    </div>
  );
}
